import React, { useEffect, useMemo } from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Header from './../../compoments/Header';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import api from './../../services/axios'
import AlertDialog from './../../compoments/AlertDialog'
import ImageUpload from './../../compoments/ImageUpload'
import Loading from './../../compoments/Loading'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Checkbox from '@material-ui/core/Checkbox'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import Input from '@material-ui/core/Input'

import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  disabled: {
    padding: 30,
    backgroundColor: 'red'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
    maxWidth: '100%',
  },
}));

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}


export default function OperadoresUpdate({ match, history }) {

  const rota = 'operadores';
  const roleName = 'Operadores';

  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);

  const [redirect, setRedirect] = React.useState(false);
  const [id, setId] = React.useState('');
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [birthday, setBirthday] = React.useState('');
  const [stateAddress, setStateAddress] = React.useState('');
  const [city, setCity] = React.useState('');
  const [message, setMessage] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [previewImage, setPreviewImage] = React.useState('');
  const [thumbnail, setThumbnail] = React.useState(null);  
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);
  const [pass, setPass] = React.useState('');
  const [filas, setFilas] = React.useState([]);
  const [filasSelected, setFilasSelected] = React.useState([]);
  const [cod, setCod] = React.useState(null);
  const [password, setPassword] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [names, setNames] = React.useState([]);
  const [showPassword, setShowPassword] = React.useState(null);

  const preview = useMemo(() => {
    return thumbnail ? URL.createObjectURL(thumbnail) : null
  }, [thumbnail])

  const loadData = async () => {
    const dataQ = await api.get('/v1/queue-table/')
    setFilas(dataQ.data.data);
    
    const queuesData = dataQ.data.data.map((i)=>{
      return {id: i.id, name: i.name};
    });

    setNames(queuesData)

    setId(match.params.id)
    const data = await api.get('/v1/operadores/' + match.params.id)
    setName(data.data.name);
    setPassword(data.data.password_txt);
    setCod(data.data.cod);
    setFilasSelected(data.data.queues.map((i)=>i.id));
    setLoading(false);
  }

  useEffect(() => {
    loadData()
  }, [])

  const save = async () => {

    const data = new FormData();
    data.append('name', name);
    data.append('cod', cod);
    data.append('password', password);
    data.append('filas', filasSelected);
    data.append('_method', 'PUT')
    try {      
      const res = await api.post('/v1/operadores/' + id, data, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        }
      })
      setAlertTitle('')
      history.push('/' + rota)
    } catch(error) {
      setAlertTitle('Erro')
      setMessage(error.response.data.errors[0].message || 'Erro')
    }

  }

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      <Header titleHeader={'Editar Clientes'} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          {loading ?  <Loading /> : 
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={`/${rota}`} >
                  {roleName}
                </Link>
                <Typography color="textPrimary">Editar</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="name"
                        label="Nome"
                        name="name"
                        autoComplete="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        required
                        id="cod"
                        label="Código do agente"
                        name="cod"
                        autoComplete="cod"
                        value={cod}
                        onChange={(e) => setCod(e.target.value)}
                        type="number"
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl  variant="outlined">
                        <InputLabel htmlFor="outlined-adornment-password">Senha</InputLabel>
                        <OutlinedInput
                          id="outlined-adornment-password"
                          type={showPassword ? 'text' : 'password'}
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={()=> setShowPassword(!showPassword)}
                                onMouseDown={(event) => {
                                  event.preventDefault();
                                }}
                                edge="end"
                              >
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>
                          }
                          labelWidth={70}
                        />
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                    <FormControl className={classes.formControl}>
                      <InputLabel id="demo-mutiple-chip-label">Filas</InputLabel>
                      <Select
                        id="demo-mutiple-chip"
                        multiple
                        value={filasSelected}
                        onChange={(e)=> { 
                          setFilasSelected(e.target.value)
                        }}
                        input={<Input id="select-multiple-chip" />}
                        renderValue={()=>{
                          return filas.filter((f)=>filasSelected.find((fi)=>fi===f.id)).map((fm)=><Chip key={fm.id} label={fm.name} className={classes.chip} />);
                        }}
                        MenuProps={MenuProps}
                      >
                        {filas.map((name) => (
                          <MenuItem key={name.id} value={name.id} style={getStyles(name.name, personName, theme)}>
                            {name.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    </Grid>
                    {/* <Grid item xs={12} >
                      <TextField
                        variant="outlined"
                        fullWidth
                        id="email"
                        label="Email"
                        name="email"
                        autoComplete="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </Grid> */}
                    {/* <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="birthday"
                        label="Aniversário"
                        type="text"
                        id="birthday"
                        value={birthday}
                        onChange={(e) => setBirthday(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="state"
                        label="Estado"
                        type="text"
                        id="state"
                        value={stateAddress}
                        onChange={(e) => setStateAddress(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        name="city"
                        label="Cidade"
                        type="text"
                        id="city"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Grid item xs={6}>
                        <ImageUpload 
                          onCropComplete={(croppedArea, croppedAreaPixels)=>{
                            setCroppedAreaPixels(croppedAreaPixels)
                          }}
                          onChange={event => setThumbnail(event.target.files[0])}
                          previewChange={preview}  
                          previewImage={previewImage}
                          remove={(flag)=> {
                            if(flag){
                              setPreviewImage('');
                            }
                            setThumbnail(null);
                          }}
                        />
                      </Grid>
                    </Grid> */}
                    {/* <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        name="password"
                        label="Senha"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        onChange={(e) => setPass(e.target.value)}
                      />
                    </Grid> */}
                    <Grid item xs={6}>
                      <Button
                        onClick={() => {
                          history.push('/' + rota)
                          // setRedirect(`/${rota}`)
                        }}
                        type="button"
                        variant="contained"
                        color="default"
                        style={{ marginRight: 30 }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={save}
                      >
                        Salvar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
          }
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}